// cSpell:disable
// 定数定義

// テスト用フォルダ https://drive.google.com/drive/folders/1iHdskdOIijZX-Pdo3_2FlaG4i4BVzpp5
// テスト出力用使い捨てフォルダ
const DISPOSABLE_FOLDER = 'disposableFolderId'

module.exports = {
  DISPOSABLE_FOLDER,

  // 作業用一時フォルダ https://drive.google.com/drive/folders/1BXZpybYXe4bwLY-Ub2VUnwrcyZp05KT9,
  TEMP_FOLDER: '1BXZpybYXe4bwLY-Ub2VUnwrcyZp05KT9',

  // クライアント一覧シート
  CLIENT_LIST_SHEET: '1JFUN6TSZ71Rp1-uvbAKBN1b3eSIUNKO4T0ENH1Ciqss',
  // 社員名簿シート
  MEMBER_LIST_SHEET: '1GR6HgEx59ek2ctyW2mn6Yx0aJiAzi1VKoPGB-SycTys',
  // 作業日報 履歴 スプレッドシート https://docs.google.com/spreadsheets/d/1UOqZr__vxoTfhH3UOnlwMql8kxvyMPO47CRuE8JNXYE/edit
  REPORT_HISTORY_SHEET: '1UOqZr__vxoTfhH3UOnlwMql8kxvyMPO47CRuE8JNXYE',

  // 出勤簿 スプレッドシート テンプレート https://docs.google.com/spreadsheets/d/1FP9JOl0K_WRCKUuGk6D56QFap_28gx_QSTsj5xu9mNo/edit
  ATTENDANCE_LEDGER_TEMPLATE: '1FP9JOl0K_WRCKUuGk6D56QFap_28gx_QSTsj5xu9mNo',
  // 出勤簿 出力フォルダ https://drive.google.com/drive/folders/1CJfuwuGVaJ6E2XyUKZ8HY8QclcIeDi3t
  ATTENDANCE_OUTPUT_FOLDER: '1CJfuwuGVaJ6E2XyUKZ8HY8QclcIeDi3t',

  // 日常点検基準表 履歴 スプレッドシート https://docs.google.com/spreadsheets/d/1a67kg9Qtic1jxLVtqd2bXhltoC15JwJZygChb8SKgJA/edit?usp=sharing
  INSPECTION_HISTORY_SHEET: '1a67kg9Qtic1jxLVtqd2bXhltoC15JwJZygChb8SKgJA',
  // 日常点検基準表 スプレッドシート テンプレート https://docs.google.com/spreadsheets/d/14EyZlT87rOXY5aV-sS5d-ALUUkHATdtTOPGO4JXoCyc/edit
  INSPECTION_LEDGER_TEMPLATE: '14EyZlT87rOXY5aV-sS5d-ALUUkHATdtTOPGO4JXoCyc',
  // 日常点検基準表 出力フォルダ https://drive.google.com/drive/folders/123kS92J0ujAPCXqYmxc_IcWpwBFZ9yOe
  INSPECTION_OUTPUT_FOLDER: '123kS92J0ujAPCXqYmxc_IcWpwBFZ9yOe',

  // ダンプ請求書 スプレッドシート テンプレート https://docs.google.com/spreadsheets/d/1dwZLiizhM8ZZsLyJ-63Wvyj2WgtpUQGe4vQCTuy_m5g/edit
  DUMP_INVOICE_TEMPLATE: '1dwZLiizhM8ZZsLyJ-63Wvyj2WgtpUQGe4vQCTuy_m5g',

  // 請求書 出力フォルダ https://drive.google.com/drive/folders/10Itlw-wJAC8MWU-z8LhDL3laGYqvLTNO
  INVOICE_OUTPUT_FOLDER: '10Itlw-wJAC8MWU-z8LhDL3laGYqvLTNO',
}
